module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10+ Ceramic White.a3a421d6.png";